/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на сохранение тикера
 */
export interface TickerSaveRequest {
  /**
   * Id первого счета в паре
   * @format uuid
   */
  firstAccountId?: string;

  /**
   * Id второго счета в паре
   * @format uuid
   */
  secondAccountId?: string;

  /**
   * Сумма в поле ввода
   * @format int32
   */
  sum?: number;

  /** Выбранная валюта валютной пары */
  selectedCurrency?: string;

  /** Признак развернутости */
  isExpanded?: boolean;

  /** Признак заблокированности */
  isBlocked?: boolean;

  /**
   * Координата X
   * @format int32
   */
  abscissa?: number;

  /**
   * Координата Y
   * @format int32
   */
  ordinate?: number;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Запрос на сохранение быстрых сумм
 */
export interface FastSumSaveRequest {
  /** Сумма */
  sum?: number;
}

/**
 * Токен
 */
export interface CustomTokenResponse {
  token?: string;
}

/**
 * Запрос на получение тикера
 */
export interface TickerGetResponse {
  /**
   * Id тикера
   * @format uuid
   */
  id?: string;

  /**
   * Id первого счета в паре
   * @format uuid
   */
  firstAccountId?: string;

  /**
   * Id второго счета в паре
   * @format uuid
   */
  secondAccountId?: string;

  /**
   * Сумма в поле ввода
   * @format int32
   */
  sum?: number;

  /** Выбранная валюта валютной пары */
  selectedCurrency?: string;

  /** Признак развернутости */
  isExpanded?: boolean;

  /** Признак заблокированности */
  isBlocked?: boolean;

  /**
   * Координата X
   * @format int32
   */
  abscissa?: number;

  /**
   * Координата Y
   * @format int32
   */
  ordinate?: number;
}

/**
 * Ответ на проверку доступа клиента
 */
export interface ClientActiveResponse {
  /** Признак активности/доступности */
  isClientActive?: boolean;
}

/**
 * ККБ документа
 */
export interface CcbDocument {
  /** Поля документа ККБ */
  fields?: CurrencyTrade;

  /** Тип документа */
  type?: DocumentType;
}

/**
 * Поля документа ККБ
 */
export interface CurrencyTrade {
  /** @format date-time */
  date?: string;

  /** @format uuid */
  id?: string;
  clientName?: string;
  inn?: string;
  kio?: string;
  okpo?: string;
  ogrn?: string;
  addressStr?: string;
  branchCode?: string;
  fullDelegateName?: string;
  phone?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface DocumentCcbResponse {
  /** Документ ККБ */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** ККБ документа */
  document?: CcbDocument;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name?: string;
  desc?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Запрос на получение счетов
 */
export interface AccountGetResponse {
  /**
   * Идентификатор счета клиента
   * @format uuid
   */
  id?: string;

  /** Двадцатизначный номер счета */
  accountNumber?: string;

  /** Буквенный код валюты счёта */
  currency?: string;

  /** Текущий остаток в валюте счета */
  balance?: number;

  /** Тип счета */
  type?: string;
}

/**
 * Запрос на исполнение/отмену/печать сделки
 */
export interface CurrencyTradeRequest {
  /**
   * ID сделки
   * @format uuid
   */
  id: string;
}

/**
 * Ответ на запросы по сделкам
 */
export interface CurrencyTradeResponse {
  /**
   * ID сделки
   * @format uuid
   */
  id?: string;

  /**
   * Номер сделки
   * @format int64
   */
  docNum?: number;

  /**
   * Дата сделки
   * @format date-time
   */
  createdAt?: string;

  /** Статус сделки */
  status?:
    | "PREPARED"
    | "PROCESSING"
    | "SENT_CHECK_BALANCE"
    | "TIMEOUT_CHECK_BALANCE"
    | "ERROR_CHECK_BALANCE"
    | "FUNDS_HOLD"
    | "CONFIRMED"
    | "ORDER_SENT"
    | "ERROR_NT_PRO"
    | "ORDER_EXECUTED"
    | "SENT_COMPLETED"
    | "ERROR_COMPLETED"
    | "EXECUTED"
    | "ORDER_REJECTED"
    | "SENT_REJECTED"
    | "ERROR_REJECTED"
    | "REJECTED"
    | "TO_REVOKE"
    | "SENT_CANCELLED"
    | "ERROR_CANCELLED"
    | "REVOKED"
    | "TO_TIMEOUT"
    | "SENT_TIMEOUT"
    | "ERROR_TIMEOUT"
    | "TIMEOUT"
    | "TIMEOUT_DEAL_EXEC"
    | "ERROR_CFT"
    | "ERROR";

  /** Описание ошибки в случае наличия */
  errorDescription?: string;
}

/**
 * Запрос на сохранение документа ОВ в ВТ
 */
export interface CurrencyTradeSaveRequest {
  /** Направление сделки */
  orderSide?: "BUY" | "SELL" | "CONVERSION";

  /**
   * ID счёта списания
   * @format uuid
   */
  debitAccountId: string;

  /** Сумма списания */
  debitSum: number;

  /**
   * ID счёта зачисления
   * @format uuid
   */
  creditAccountId: string;

  /** Сумма зачисления */
  creditSum: number;

  /** Курс обмена */
  rate: number;
}

/**
 * Ответ на запрос детальной формы сделки
 */
export interface CurrencyTradeDetailResponse {
  /**
   * ID документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  docNum?: string;

  /**
   * Дата документа
   * @format date-time
   */
  docDate?: string;

  /**
   * ID клиента
   * @format uuid
   */
  clientId?: string;

  /** Наименование клиента */
  fullName?: string;

  /** ИНН клиента */
  inn?: string;

  /** КИО клиента */
  kio?: string;

  /** ОКПО клиента */
  okpo?: string;

  /** ОГРН клиента */
  ogrn?: string;

  /** Адрес клиента */
  addressStr?: string;

  /**
   * ID подразделения банка
   * @format uuid
   */
  branchId?: string;

  /** Код подразделения банка */
  branchCode?: string;

  /** Наименование подразделения банка */
  branchName?: string;

  /** Телефон пользователя клиента */
  phone?: string;

  /** Тип заявки */
  orderType?: string;

  /** Двадцатизначный номер счёта списания */
  debitAccount?: string;

  /** Сумма списания */
  debitSum?: number;

  /** Буквенный код валюты списания */
  debitCurrency?: string;

  /** Двадцатизначный номер счёта зачисления */
  creditAccount?: string;

  /** Сумма зачисления */
  creditSum?: number;

  /** Буквенный код валюты зачисления */
  creditCurrency?: string;

  /** Курс обмена */
  rate?: number;

  /** Статус документа */
  state?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title owb-ms-prd-currency-trading
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-currency-trading.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Тикеры
     * @name GetTickers
     * @summary Получение тикеров клиента
     * @request GET:/api/currency-trading/v1/external/tickers
     * @secure
     */
    getTickers: (params: RequestParams = {}) =>
      this.request<TickerGetResponse[], ErrorMessage>({
        path: `/api/currency-trading/v1/external/tickers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Тикеры
     * @name SaveTickers
     * @summary Сохранение тикеров клиента
     * @request POST:/api/currency-trading/v1/external/tickers
     * @secure
     */
    saveTickers: (data: TickerSaveRequest[], params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency-trading/v1/external/tickers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Быстрые суммы
     * @name GetClientFastSums
     * @summary Получение быстрых сумм клиента
     * @request GET:/api/currency-trading/v1/external/fast-sums
     * @secure
     */
    getClientFastSums: (params: RequestParams = {}) =>
      this.request<number[], ErrorMessage>({
        path: `/api/currency-trading/v1/external/fast-sums`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Быстрые суммы
     * @name SaveClientFastSums
     * @summary Сохранение быстрых сумм
     * @request POST:/api/currency-trading/v1/external/fast-sums
     * @secure
     */
    saveClientFastSums: (
      data: FastSumSaveRequest[],
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency-trading/v1/external/fast-sums`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Токен
     * @name GetToken
     * @summary Получение токена
     * @request GET:/api/currency-trading/v1/external/token
     * @secure
     */
    getToken: (params: RequestParams = {}) =>
      this.request<CustomTokenResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Общий системный ресурс
     * @name IsCurrencyTradingAvailable
     * @summary Проверка доступности модуля Валютные торги
     * @request GET:/api/currency-trading/v1/external/system-info/currency-trading-availability
     * @secure
     */
    isCurrencyTradingAvailable: (params: RequestParams = {}) =>
      this.request<boolean, ErrorMessage>({
        path: `/api/currency-trading/v1/external/system-info/currency-trading-availability`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Полномочия клиента
     * @name IsClientActiveNtPro
     * @summary Проверка доступности NtPro для клиента
     * @request GET:/api/currency-trading/v1/external/permission/is-client-active-ntpro
     * @secure
     */
    isClientActiveNtPro: (params: RequestParams = {}) =>
      this.request<ClientActiveResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/permission/is-client-active-ntpro`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Полномочия клиента
     * @name IsClientHasAccess
     * @summary Проверка доступа клиента в Валютные торги по признаку блокировки СФМ
     * @request GET:/api/currency-trading/v1/external/permission/client-access
     * @secure
     */
    isClientHasAccess: (params: RequestParams = {}) =>
      this.request<ClientActiveResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/permission/client-access`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetCcb
     * @summary Получение ККБ
     * @request GET:/api/currency-trading/v1/external/confirmation/order-ccb
     * @secure
     */
    getCcb: (
      query: { action: "CREATE_DEAL" | "LOGIN" },
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/currency-trading/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/currency-trading/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета
     * @name GetClientAccounts
     * @summary Получение счетов клиента
     * @request GET:/api/currency-trading/v1/external/accounts
     * @secure
     */
    getClientAccounts: (params: RequestParams = {}) =>
      this.request<AccountGetResponse[], ErrorMessage>({
        path: `/api/currency-trading/v1/external/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name CancelCurrencyTrade
     * @summary Отказ от сделки
     * @request POST:/api/currency-trading/v1/external/currency-trades/cancel
     * @secure
     */
    cancelCurrencyTrade: (
      data: CurrencyTradeRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyTradeResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name CreateCurrencyTrade
     * @summary Создание сделки
     * @request POST:/api/currency-trading/v1/external/currency-trades/create
     * @secure
     */
    createCurrencyTrade: (
      data: CurrencyTradeSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyTradeResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name ExecuteCurrencyTrade
     * @summary Исполнение сделки
     * @request POST:/api/currency-trading/v1/external/currency-trades/execute
     * @secure
     */
    executeCurrencyTrade: (
      data: CurrencyTradeRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyTradeResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/execute`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name FastCurrencyTrade
     * @summary Мгновенная сделка
     * @request POST:/api/currency-trading/v1/external/currency-trades/fast-trade
     * @secure
     */
    fastCurrencyTrade: (
      data: CurrencyTradeSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyTradeResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/fast-trade`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name Print
     * @summary Получение печатной формы
     * @request GET:/api/currency-trading/v1/external/currency-trades/print/{id}
     * @secure
     */
    print: (id: string, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/print/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name TimeoutCurrencyTrade
     * @summary Отмена сделки по таймауту
     * @request POST:/api/currency-trading/v1/external/currency-trades/timeout
     * @secure
     */
    timeoutCurrencyTrade: (
      data: CurrencyTradeRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyTradeResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/timeout`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сделки
     * @name GetCurrencyTradeDetail
     * @summary Получение детальной информации сделки
     * @request GET:/api/currency-trading/v1/external/currency-trades/{id}
     * @secure
     */
    getCurrencyTradeDetail: (id: string, params: RequestParams = {}) =>
      this.request<CurrencyTradeDetailResponse, ErrorMessage>({
        path: `/api/currency-trading/v1/external/currency-trades/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
